// extracted by mini-css-extract-plugin
export default {"top-settings":"TopSettings_top-settings__ZjBo6"};